"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.AUDIT, (table)=>{
        table.smallint('version').unsigned().defaultTo(0);
        table.string('fk_user_id', 20);
        // this is a foreign key to keep any reference id, like view id, webhook id, etc
        table.string('fk_ref_id', 20);
        table.string('fk_parent_id', 20);
        table.text('user_agent');
    });
};
const down = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.AUDIT, (table)=>{
        table.dropColumn('version');
        table.dropColumn('fk_user_id');
        table.dropColumn('fk_ref_id');
        table.dropColumn('fk_parent_id');
        table.dropColumn('user_agent');
    });
};
